export function nullOrUndefined(val: any): boolean {
    return val === null || val === undefined;
}